export default __webpack_public_path__ + "static/media/azure_white.6ddde94f.svg";